import { render, staticRenderFns } from "./Sedes-add.vue?vue&type=template&id=2416f917"
import script from "./Sedes-add.vue?vue&type=script&lang=js"
export * from "./Sedes-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports